export default __webpack_public_path__ + "static/media/illustration-algowork-w@2x.1e8dbf7b.webp";